import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import { useEstablishmentInfrastructures } from '@/common/hooks/queries/useEstablishmentInfrastructures'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import {
  EstablishmentInfrastructureData,
  EstablishmentInfrastructureTableItem,
} from '@/common/types/establishmentInfrastructure'
import { cn } from '@/common/utils/cn'
import { defaultColumns } from '@/features/maintenance/establishmentInfrastructures/constants/columns.constant'
import { EstablishmentInfrastructuresTransformer } from '@/features/maintenance/establishmentInfrastructures/services/establishmentInfrastructuresTransformer'
import { ConstructionIcon, SearchIcon } from 'lucide-react'

const List = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [search, setSearch] = useDebounce(filterParams.search || '')

  const {
    data: establishmentInfrastructures,
    meta,
    isPending: establishmentInfrastructuresIsPending,
    error: establishmentInfrastructuresError = {} as any,
    refetch: refetchEstablishmentInfrastructures,
  } = useEstablishmentInfrastructures({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<EstablishmentInfrastructureData[], EstablishmentInfrastructureTableItem[]>({
      transformer: EstablishmentInfrastructuresTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<ConstructionIcon className="size-10" strokeWidth={1} />}
        title="Infraestrutura da Rede Credenciada"
        createButtonText="Nova Infraestrutura"
        dataTestid="create_establishment_infrastructure_button"
        operationKlassToCheckPermission="Admin::Maintenance::EstablishmentInfrastructures::Create"
        disableCreateButton={establishmentInfrastructuresIsPending || establishmentInfrastructuresError?.status === 403}
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={establishmentInfrastructuresError?.status}
        refetchFunction={refetchEstablishmentInfrastructures}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value)
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
              }}
              value={filterParams.search}
            />
          </div>

          <Table
            className={cn('max-h-screen', {
              'shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]': !!establishmentInfrastructures?.length,
            })}
            columns={defaultColumns}
            isLoadingData={establishmentInfrastructuresIsPending}
            page={filterParams.page || 1}
            rows={establishmentInfrastructures}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default List
